/// <amd-module name="Wit/UI/WorkItem/ReferencedArtifact" />
export * from "./Components/ReferencedArtifact/ReferencedArtifact";
export * from "./Components/ReferencedArtifact/ReferencedArtifactError";
